module.exports = __webpack_public_path__ + "img/d1.5bbe5456.png";